<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: "GMOPaymentCardDialog",
  props: {
    ticket: Object,
    value: Boolean,
  },
  data() {
    return {
      loading: false,
      cardDialog: false,
      mulpay: null,
      mulPayFormElements: null,
      cardHolderName: null
    }
  },
  async mounted() {
    console.log("dialog mounted")
  },
  computed: {
    // ...mapState('gmo', ['mulpay', "mpToken"]),
    ...mapGetters('gmo', ['cardInputStyle', 'expiryInputStyle', 'cvcInputStyle',]),
    isOpened: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    amount() {
      return this.ticket?.price * 99000
    },
  },
  watch:{
    value(newVal, oldVal) {
      if(newVal) {
        this.openDialog()
      }
    }
  },
  filters: {
    price(v) {
      return v && v.toLocaleString('ja-JP')
    }
  },
  methods: {
    ...mapActions('gmo', ['createMulpay']),
    async openDialog() {
      this.mulpay = await this.createMulpay()
      const elements = this.mulpay.createElements();
      const cardNumberInputElement =
          elements.create('cardNumber', {
            style: this.cardInputStyle,
            placeholder: '1234 5678 9012 3456'
          }),
        expiryInputElement = elements.create('cardExpiry', {style: this.expiryInputStyle}),
        cvcInputElement = elements.create('cardCvc', {style: this.cvcInputStyle});

      cardNumberInputElement.mount(this.$refs.gmoCardNumber)
      expiryInputElement.mount(this.$refs.gmoCardExpiry)
      cvcInputElement.mount(this.$refs.gmoCardCvc)

      this.mulPayFormElements = [
        cardNumberInputElement,
        expiryInputElement,
        cvcInputElement
      ]
    },
    //testcard: 4100000000000100
    /**
     *  @return {Promise<import('@mul-pay/mptoken-js').TokenObj>}
     *  */
    async getMpToken() {
      console.log("getMpToken", this.mulpay)
      // this.mulpay = await this.createMulpay()

      /** @type {import('@mul-pay/mptoken-js').TokenResponse} */
      console.log("getMpToken",  this.mulPayFormElements[0],this.cardHolderName)
      const response = await this.mulpay.getTokenThroughIframe(
        this.mulPayFormElements[0],
        this.cardHolderName,
        {tokenNumber: 1}
      )
      console.log("response", response)

      if (response?.result === 'success') {
        const tokenObject = /** @type {TokenObj} */ (response);
        console.log(tokenObject)
        return tokenObject;
      } else {
        const error = /** @type {ErrorResponse} */ (response);
        console.error(error)
        throw new Error('カード決済エラー', error)
      }
    },
    async submit() {
      try {
        this.loading = true
        const mpToken = await this.getMpToken();
        console.log('mpToken response:', mpToken);
        // alert("token" + mpToken.tokenList[0])
        this.$emit('submit', {
          name: this.name,
          token: mpToken.tokenList[0]
        })
      } catch (e) {
        console.error(e)
        alert("カード決済に失敗しました")
      } finally {
        this.loading = false
      }
    },
    cancel() {
      this.isOpened = false
      this.cleanup()
    },
    cleanup() {
      this.mulPayFormElements.forEach(function (element) {
        // カード情報入力フォームをアンマウントする
        element.clear();
      });
    },
  }
}
</script>

<template>

  <v-dialog v-model="isOpened" width="500">
    <v-card>
      <v-card-title class="">
        <v-icon>mdi-credit-card</v-icon>
        カード決済
      </v-card-title>

      <v-card-text class="text-left">


        <v-row>
          <v-col>
            <div class="d-flex align-center" style="display: flex;justify-content: space-between;margin: 1rem 0">
              <span class="payment-card__amount-label" style="font-size: 1rem;font-weight: bold">お支払い金額</span>
              <span class="payment-card__amount-value" style="font-size: 2rem;font-weight: bold">¥{{
                  amount  | price
                }}</span>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <p style="font-size: 12px">
              <v-icon x-small>mdi-lock</v-icon>
              カード情報はGMOペイメントゲートウェイ上のiframeを通じて送信され、当サイトを通過しません。
            </p>
            <label for="cardNumber" style="vertical-align: top">カード番号</label>
            <v-input :messages="['iframe']">
              <div id="gmo-card-number-wrapper" ref="gmoCardNumber" class="input-wrapper"></div>
              <template v-slot:message="{ message }">
                <span class=""><v-icon x-small>mdi-lock</v-icon>{{ message }}</span>
              </template>
            </v-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <label for="expiry">有効期限</label>
            <v-input :messages="['iframe']">
              <div id="gmo-card-expiry-wrapper" ref="gmoCardExpiry" class="input-wrapper"></div>
              <template v-slot:message="{ message }">
                <span class=""><v-icon x-small>mdi-lock</v-icon>{{ message }}</span>
              </template>
            </v-input>
          </v-col>
          <v-col>
            <label for="cvc">セキュリティコード</label>
            <v-input :messages="['iframe']">
              <div id="gmo-card-cvc-wrapper" ref="gmoCardCvc" class="input-wrapper"></div>
              <template v-slot:message="{ message }">
                <span class=""><v-icon x-small>mdi-lock</v-icon>{{ message }}</span>
              </template>
            </v-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="cardHolderName" placeholder="TARO YAMADA" label="カード名義(任意)"
                          outlined></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">
          キャンセル
        </v-btn>
        <v-btn color="primary" @click.stop="submit" :disabled="loading" :loading="loading">
          決済する
        </v-btn>
        <br>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.input-wrapper {
  border-radius: 4px;
  border: solid 1px rgba(0, 0, 0, 0.38);
  padding: 10px;
  width: 100%;
}
</style>
